import React, { useEffect, useState } from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import PostbackPageComponent from './PostbackPage/PostbackPage.container';
import PostbackActions from '../../../actions/PostbackActions';

const CreatePostbackPage = ({ t, ...props }) => {
    const staticNames = t?.postbackPage?.creating || {};
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        PostbackActions.resetState();
        setIsReady(true);
    }, []);

    if (!isReady) {
        return null;
    }

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content tools">
                <div className="ibox postback create-postback">
                    <PostbackPageComponent
                        {...props}
                    />
                </div>
            </section>
        </React.Fragment>
    );
};

CreatePostbackPage.propTypes = {
    t: PropTypes.object
};

CreatePostbackPage.defaultProps = {
    t: {}
};

export default withTranslation(CreatePostbackPage);